import React from 'react';

import InsuranceSettingMenus from './InsuranceSettingMenus';

const InsuranceSetting = ({ activeMenu, children }) => (
  <div>
    <InsuranceSettingMenus activeMenu={activeMenu} />
    {children}
  </div>
);

export default InsuranceSetting;
